<svg width="94" height="66" viewBox="0 0 94 66" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g #pathGroup>
    <path
      d="M82.1629 58.3081C82.9562 58.6009 83.8386 58.1991 84.0998 57.3949C84.361 56.5906 83.8849 55.7407 83.071 55.5116L77.5868 53.9677C76.9501 53.7885 76.2902 54.1627 76.0859 54.7918C75.8815 55.421 76.1974 56.1066 76.818 56.3356L82.1629 58.3081Z"
    />
    <path
      d="M83.7554 52.6502C84.585 52.8143 85.3929 52.2801 85.5243 51.4447C85.6557 50.6093 85.0521 49.843 84.2122 49.7446L78.5557 49.0819C77.8976 49.0048 77.3035 49.4808 77.2005 50.1353C77.0976 50.7898 77.5186 51.4163 78.1686 51.5449L83.7554 52.6502Z"
    />
    <path
      d="M84.4376 46.8098C85.2841 46.8425 85.9998 46.1827 85.9998 45.3357C85.9998 44.4886 85.284 43.8288 84.4376 43.8615L78.7577 44.0811C78.0909 44.1069 77.5737 44.6684 77.5737 45.3357C77.5737 46.0029 78.0909 46.5644 78.7577 46.5902L84.4376 46.8098Z"
    />
    <path
      d="M84.2122 40.9273C85.0521 40.8289 85.6557 40.0627 85.5243 39.2273C85.3929 38.3919 84.585 37.8577 83.7554 38.0218L78.1686 39.127C77.5186 39.2556 77.0976 39.8821 77.2005 40.5366C77.3035 41.1912 77.8976 41.6671 78.5557 41.59L84.2122 40.9273Z"
    />
    <path
      d="M83.071 35.1606C83.8849 34.9315 84.361 34.0816 84.0998 33.2773C83.8386 32.4731 82.9562 32.0713 82.1629 32.364L76.818 34.3366C76.1974 34.5656 75.8815 35.2512 76.0859 35.8804C76.2902 36.5095 76.9501 36.8837 77.5869 36.7044L83.071 35.1606Z"
    />
    <path
      d="M81.0355 29.6461C81.8034 29.2914 82.1404 28.3781 81.7557 27.6247C81.371 26.8714 80.4355 26.6121 79.6979 27.026L74.7316 29.8132C74.1538 30.1375 73.95 30.8665 74.2513 31.4566C74.5525 32.0466 75.2637 32.3114 75.8652 32.0336L81.0355 29.6461Z"
    />
    <path
      d="M78.1582 24.519C78.8612 24.0483 79.0515 23.0943 78.5536 22.4103C78.0558 21.7262 77.0905 21.6153 76.4265 22.1395L71.9585 25.6666C71.4375 26.0779 71.3503 26.8319 71.7409 27.3686C72.1315 27.9053 72.8764 28.0551 73.428 27.6858L78.1582 24.519Z"
    />
    <path
      d="M74.5144 19.9028C75.1355 19.3284 75.1754 18.357 74.5773 17.7589C73.9791 17.1607 73.0077 17.2007 72.4334 17.8217L68.5689 22.0003C68.1179 22.488 68.1494 23.2473 68.6191 23.717C69.0888 24.1867 69.8482 24.2183 70.3359 23.7672L74.5144 19.9028Z"
    />
    <path
      d="M70.1962 15.9094C70.7204 15.2453 70.6095 14.28 69.9255 13.7822C69.2415 13.2844 68.2874 13.4747 67.8168 14.1777L64.65 18.9079C64.2807 19.4595 64.4304 20.2044 64.9671 20.595C65.5038 20.9856 66.2579 20.8984 66.6692 20.3774L70.1962 15.9094Z"
    />
    <path
      d="M65.3098 12.638C65.7238 11.9004 65.4645 10.9649 64.7111 10.5802C63.9578 10.1955 63.0444 10.5325 62.6898 11.3004L60.3023 16.4707C60.0245 17.0722 60.2893 17.7833 60.8793 18.0846C61.4694 18.3859 62.1984 18.1821 62.5226 17.6043L65.3098 12.638Z"
    />
    <path
      d="M59.9722 10.1731C60.265 9.37976 59.8632 8.49735 59.0589 8.23612C58.2547 7.97488 57.4048 8.451 57.1756 9.26498L55.6318 14.7491C55.4526 15.3858 55.8268 16.0457 56.4559 16.2501C57.085 16.4544 57.7707 16.1385 57.9997 15.518L59.9722 10.1731Z"
    />
    <path
      d="M54.3142 8.58028C54.4783 7.75068 53.9441 6.94287 53.1087 6.81145C52.2733 6.68004 51.5071 7.28361 51.4087 8.12354L50.746 13.78C50.6689 14.4381 51.1448 15.0322 51.7994 15.1352C52.4539 15.2382 53.0804 14.8171 53.209 14.1671L54.3142 8.58028Z"
    />
    <path
      d="M48.4741 7.89814C48.5068 7.0517 47.847 6.33594 47 6.33594C46.1529 6.33594 45.4931 7.05171 45.5258 7.89816L45.7454 13.5781C45.7712 14.2448 46.3327 14.762 47 14.762C47.6672 14.762 48.2287 14.2448 48.2545 13.5781L48.4741 7.89814Z"
    />
    <path
      d="M42.5914 8.12354C42.493 7.28361 41.7267 6.68004 40.8913 6.81145C40.0559 6.94287 39.5217 7.75068 39.6859 8.58028L40.7911 14.1671C40.9197 14.8171 41.5462 15.2382 42.2007 15.1352C42.8553 15.0322 43.3312 14.4381 43.2541 13.78L42.5914 8.12354Z"
    />
    <path
      d="M36.8242 9.26498C36.5951 8.451 35.7451 7.97488 34.9409 8.23612C34.1366 8.49735 33.7348 9.37976 34.0276 10.1731L36.0001 15.518C36.2292 16.1385 36.9148 16.4544 37.5439 16.2501C38.1731 16.0457 38.5473 15.3858 38.368 14.7491L36.8242 9.26498Z"
    />
    <path
      d="M31.3101 11.3004C30.9555 10.5325 30.0422 10.1955 29.2888 10.5802C28.5355 10.9649 28.2761 11.9004 28.6901 12.638L31.4773 17.6043C31.8015 18.1821 32.5306 18.3859 33.1206 18.0846C33.7107 17.7833 33.9754 17.0722 33.6977 16.4707L31.3101 11.3004Z"
    />
    <path
      d="M26.183 14.1777C25.7124 13.4747 24.7583 13.2844 24.0743 13.7822C23.3903 14.28 23.2794 15.2453 23.8036 15.9094L27.3307 20.3774C27.742 20.8984 28.496 20.9856 29.0327 20.595C29.5694 20.2044 29.7191 19.4595 29.3498 18.9079L26.183 14.1777Z"
    />
    <path
      d="M21.5666 17.8217C20.9922 17.2007 20.0209 17.1607 19.4227 17.7589C18.8245 18.357 18.8645 19.3284 19.4855 19.9028L23.6641 23.7672C24.1518 24.2183 24.9111 24.1867 25.3808 23.717C25.8506 23.2473 25.8821 22.488 25.4311 22.0003L21.5666 17.8217Z"
    />
    <path
      d="M17.5737 22.1395C16.9097 21.6153 15.9444 21.7262 15.4465 22.4103C14.9487 23.0943 15.139 24.0483 15.842 24.519L20.5722 27.6858C21.1238 28.0551 21.8687 27.9053 22.2593 27.3686C22.6499 26.8319 22.5627 26.0779 22.0417 25.6666L17.5737 22.1395Z"
    />
    <path
      d="M14.3021 27.0261C13.5645 26.6121 12.6289 26.8714 12.2443 27.6247C11.8596 28.3781 12.1965 29.2915 12.9645 29.6461L18.1348 32.0336C18.7363 32.3114 19.4474 32.0466 19.7487 31.4566C20.05 30.8665 19.8461 30.1375 19.2684 29.8132L14.3021 27.0261Z"
    />
    <path
      d="M11.8369 32.364C11.0436 32.0713 10.1612 32.4731 9.89994 33.2773C9.6387 34.0816 10.1148 34.9315 10.9288 35.1606L16.4129 36.7044C17.0496 36.8837 17.7095 36.5095 17.9139 35.8803C18.1182 35.2512 17.8024 34.5656 17.1818 34.3366L11.8369 32.364Z"
    />
    <path
      d="M10.2443 38.0218C9.41474 37.8577 8.60693 38.3919 8.47552 39.2273C8.3441 40.0627 8.94767 40.8289 9.7876 40.9273L15.444 41.59C16.1021 41.6671 16.6963 41.1912 16.7993 40.5367C16.9022 39.8821 16.4812 39.2556 15.8312 39.127L10.2443 38.0218Z"
    />
    <path
      d="M8 45.3356C8 44.4886 8.71577 43.8288 9.56221 43.8615L15.2422 44.0811C15.9089 44.1069 16.4261 44.6684 16.4261 45.3356C16.4261 46.0029 15.9089 46.5644 15.2421 46.5902L9.56222 46.8098C8.71577 46.8425 8 46.1827 8 45.3356Z"
    />
    <path
      d="M9.7876 49.7446C8.94767 49.843 8.3441 50.6093 8.47552 51.4447C8.60693 52.2801 9.41474 52.8143 10.2443 52.6502L15.8312 51.5449C16.4812 51.4163 16.9022 50.7898 16.7993 50.1353C16.6963 49.4808 16.1021 49.0048 15.444 49.0819L9.7876 49.7446Z"
    />
    <path
      d="M10.9288 55.5116C10.1148 55.7407 9.6387 56.5906 9.89994 57.3949C10.1612 58.1991 11.0436 58.6009 11.8369 58.3081L17.1818 56.3356C17.8024 56.1066 18.1182 55.421 17.9139 54.7918C17.7095 54.1627 17.0496 53.7885 16.4129 53.9677L10.9288 55.5116Z"
    />
  </g>
</svg>
@if (state() === 'rating-hidden') {
  <rt-icon name="visibility-off" size="small"></rt-icon>
} @else {
  <rt-interview-evaluation-rating
    [rating]="rating() || 50"
    [tooltip]="false"
    [colorize]="false"
    size="small"
    variant="default no-padding"
  ></rt-interview-evaluation-rating>
}
<span class="value">
  @if (state() === 'rating-hidden') {
    ∗∗∗
  } @else {
    {{ rating() !== null ? rating() + '&thinsp;%' : '—' }}
  }
</span>
